import {observer} from 'mobx-react-lite'
import React from 'react'
import {StatisticsTiles} from './components/tiles'
import {useTaskEventLogStore} from './task-event-log-store'

export const TaskEventLogTiles = observer(() => {
  const [_, store] = useTaskEventLogStore()

  return (
    <>
      {store.events &&
        Object.keys(store.eventsByDay).map(date => (
          <StatisticsTiles
            key={date}
            date={date}
            eventsByDay={store.eventsByDay}
          />
        ))}
    </>
  )
})
